<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_27",
      next: "P_29",
      topic: "Estás en: Taller ¿Qué es crédito? / ¿En qué consiste?",
      dialog: false,
      respuesta: null,
      sent: false,
      hideAll: false,
      resultado: 0,
      correcta: 1,
      fontSize: 24,
    };
  },
  methods: {
    sendResult() {
      if (this.correcta == this.respuesta) {
        this.resultado = 1;
      }
      this.sent = true;
      eventBus.$emit("send_result", this.resultado);
      eventBus.$emit("send_suspend_data", this.respuesta);
    }
  },
  created() {
    if ("suspend_data" in this.$parent) {
      if (this.$parent.currentPage in this.$parent.suspend_data) {
        this.respuesta = this.$parent.suspend_data[this.$parent.currentPage];
        this.sendResult();
      }
    }
  },
  computed: {
    responseIsNone() {
      return {
        "btn-primary": this.respuesta != "none",
        "btn-secondary": this.respuesta == "none"
      };
    }
  }
};
</script>

<style lang="stylus">
.btn-reactivo, .btn-reactivo:hover {
  height: 100%;
  width: 100%;
  color: #D4EDFC !important;
  border: 3px;
  border-color: #49A5E6 !important;
}

.reactivo-container {
  position: absolute;
}

.correctClass {
  border-color: #48AE64;
  background-color: rgba(136, 202, 154, 0.2);
}

.incorrectClass {
  border-color: #D0021B;
  background-color: rgba(218, 56, 81, 0.2);
}

.tooltip {
  // ...
  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: white;
      position: absolute;
      color: black;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }
  }
}
</style> 


<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, align-center justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(:back='last') {{topic}}
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA 1 DE 5
            v-card-text.titulo24Reg
              | ¿Qué información corresponde al costo anual total? 
            v-card-text.parrafoDestacadoB.text-center
              | Selecciona una opción
            v-container(grid-list-xs) 
              v-layout(row wrap)
                v-flex.xs12.md4
                  v-btn.button_select.v-card.grey.mt-0.pt-0(dark flat min-height=70 v-bind:class="{ balance_inactive: (respuesta==0) }" @click="respuesta=0")
                    v-icon.pt-1(small v-bind:class="{'primary--text': (respuesta==0) }" v-if="respuesta==0") fas fa-circle
                    v-icon.pt-1(small v-bind:class="{'primary--text': (respuesta==0) }" v-else) far fa-circle
                  v-container.grey.lighten-4.px-2
                    v-card.grey.lighten-4.text-xs-left(style="overflow-y: scroll; height:140px;" flat min-height=140)
                      .bt Características:
                      ul.b
                        li.b Es el cargo adicional que debemos pagar por utilizar el crédito. Puede ser:  
                          ul
                            li fija
                            li variable 
                v-flex.xs12.md4 
                  v-btn.button_select.v-card.grey.mt-0.pt-0(v-if="!sent" dark flat min-height=70 v-bind:class="{ balance_inactive: (respuesta==1) }" @click="respuesta=1")
                    v-icon.pt-1(small v-bind:class="{'primary--text': (respuesta==1) }" v-if="respuesta==1") fas fa-circle
                    v-icon.pt-1(small v-bind:class="{'primary--text': (respuesta==1) }" v-else) far fa-circle
                  v-card.button_select.v-card.toolTip.mt-0.pt-4(v-if="sent && (respuesta==1)" dark flat min-height=70)
                    b.title.pt-2 Costo anual total (CAT)
                    v-icon.px-2.my-4.green.check(small color="white") fas fa-check
                  v-container.grey.lighten-4.px-2
                    v-card.grey.lighten-4.text-xs-left(style="overflow-y: scroll; height:140px;" flat min-height=140)
                      .bt Características:
                      ul.b
                        li.b Es la tasa anualizada de todos los gastos que se generan al tener un crédito, como intereses, comisiones y primas. 
                v-flex.xs12.md4  
                  v-btn.button_select.v-card.grey.mt-0.pt-0(dark flat min-height=70 v-bind:class="{ balance_inactive: (respuesta==2) }" @click="respuesta=2")
                    v-icon.pt-1(small v-bind:class="{'primary--text': (respuesta==2) }" v-if="respuesta==2") fas fa-circle
                    v-icon.pt-1(small v-bind:class="{'primary--text': (respuesta==2) }" v-else) far fa-circle
                  v-container.grey.lighten-4.px-2
                    v-card.grey.lighten-4.text-xs-left(style="overflow-y: scroll; height:140px;" flat min-height=140)
                      .bt Características:
                      ul.b
                        li.b Es el tiempo en el que se termina el crédito. Puede ser hasta de 30 años. Los más comunes son de 5, 10, 15 y 20 años. 
              v-layout(row wrap align-center justify-center)
                v-flex.xs12.md4  
                  v-btn.button_select.v-card.grey.mt-0.pt-0(dark flat min-height=70 v-bind:class="{ balance_inactive: (respuesta==3) }" @click="respuesta=3")
                    v-icon.pt-1(small v-bind:class="{'primary--text': (respuesta==3) }" v-if="respuesta==3") fas fa-circle
                    v-icon.pt-1(small v-bind:class="{'primary--text': (respuesta==3) }" v-else) far fa-circle
                  v-container.grey.lighten-4.px-2
                    v-card.grey.lighten-4.text-xs-left(style="overflow-y: scroll; height:140px;" flat min-height=140)
                      .bt Características:
                      ul.b
                        li.b Es la cantidad que prestará el banco. Varía de acuerdo a la situación en el buró de crédito del cliente, su capacidad de pago y las políticas internas del banco. 
                v-flex.xs12.md4  
                  v-btn.button_select.v-card.grey.mt-0.pt-0(dark flat min-height=70 v-bind:class="{ balance_inactive: (respuesta==4) }" @click="respuesta=4")
                    v-icon.pt-1(small v-bind:class="{'primary--text': (respuesta==4) }" v-if="respuesta==4") fas fa-circle
                    v-icon.pt-1(small v-bind:class="{'primary--text': (respuesta==4) }" v-else) far fa-circle
                  v-container.grey.lighten-4.px-2
                    v-card.grey.lighten-4.text-xs-left(style="overflow-y: scroll; height:140px;" flat min-height=140)
                      .bt Características:
                      ul.b
                        li.b Incluye beneficios como:
                          ul
                            li Descuentos 
                            li Puntos 
                            li Meses sin intereses 
                            li Pago posterior a la compra 
                            li Programas de recompensas.               
            v-layout(row, justify-center)
              v-flex
                v-btn.btn(v-if="!sent" color='accent' v-bind:class='responseIsNone' :disabled="respuesta==null" style='z-index:2', @click.prevent='sent=true; dialog=true')
                  | Revisar                           
                v-btn.btn.dialog_btn(v-else color='accent' style="z-index:2; !important" @click.prevent="nextPage(next)")
                  | Siguiente
                v-dialog(v-model='dialog ', persistent, max-width='930px ')
                  v-layout(row, justify-center)
                    v-flex(text-xs-center)
                      v-card.pb-4
                        div(v-if='sent && (respuesta==correcta) ')
                          v-layout(v-if='dialog ')
                            v-flex(text-xs-center)
                              img.dialog_img(src='@/assets/ManoOk.png')
                          v-spacer.my-1.py-4
                          v-card-text.headline.py-5
                            | ¡Muy Bien!
                          v-btn.btn.dialog_btn(color='accent', @click.prevent="dialog=false;")
                            | Continuar
                        div(v-if='sent && (respuesta!=correcta) ')
                          v-layout(v-if='dialog ')
                            v-flex(text-xs-center)
                              img.dialog_img(src='@/assets/ManoStop.png')
                          v-spacer.my-1.py-4
                          v-card-text.headline.py-5
                            | Inténtalo de nuevo
                          v-btn.btn.dialog_btn(color='accent ', @click.prevent="dialog=false; respuesta=null; sent=false;")
                            | Continuar
          l-progress(:value='this.$parent.currentPage')
</template>

<style scoped lang="stylus">


.b 
.bt
  color #6E6E6E
  font-weight normal
  font-size 12px
  line-height 2em

.bt
  font-weight bold
  padding-left 24px

.button_select
  width 100% !important
  height 70px !important
  margin 0
  padding 0
  box-shadow none
  border-radius 0

.check
  position absolute 
  top -24px
  right 0px

::-webkit-scrollbar
  -webkit-appearance none
  width: 7px

::-webkit-scrollbar-thumb 
  border-radius 4px
  background-color rgba(0,0,0,.5)
  -webkit-box-shadow 0 0 1px rgba(255,255,255,.5)


</style>

